<script setup>
import TheMainScreen from "@/components/sections/TheMainScreen.vue";
import TheParticipation from "@/components/sections/TheParticipation.vue";
import TheCollaboration from "@/components/sections/TheCollaboration.vue";
import TheRestaurant from "@/components/sections/TheRestaurant.vue";
import TheCollection from "@/components/sections/TheCollection.vue";
import ThePartners from "@/components/sections/ThePartners.vue";
import ThePrizes from "@/components/sections/ThePrizes.vue";
import TheGames from "@/components/sections/TheGames.vue";
import TheWinners from "@/components/sections/TheWinners.vue";
import TheFaq from "@/components/sections/TheFaq.vue";

</script>
<template>
	<TheMainScreen />
	<TheParticipation />
	<TheCollaboration />
	<TheRestaurant />
	<TheCollection />
	<ThePartners />
 	<ThePrizes /> 
	<TheGames />
	<TheWinners />
	<TheFaq />
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.v-enter-active,
.v-leave-active {
	transition: opacity 0.8s ease, transform 0.8s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(100%);
}
</style>
